<template>
  <section class="chat">
    <chat-login v-show="!userLoggedIn" :userEmail="userEmail"></chat-login>
    <vue-snotify></vue-snotify>
    <!-- <iframe src="https://open.rocket.chat/home" width="100%" height="100%" frameborder="0">
    </iframe>-->
    <div class="row" v-if="invalidUser && userLoggedIn">
      <div class="col-md-12 text-center">
        <h3>User is not registered for SupotterChat.</h3>
      </div>
    </div>

    <div class="row" v-if="!invalidUser && userLoggedIn">
      <div class="col-md-12">
        <!-- <button
          type="button"
          class="btn btn-secondary py-3 mb-4 text-center d-lg-none aside-toggler"
          @click="asideToggler"
        >
          <i class="ti-menu mr-0 icon-md"></i>
        </button>-->
        
        <div class="card chat-app-wrapper">
          <div class="chatbar-toggle">
            <button @click= "myFilter" type="button" class="navbar-toggler navbar-toggler-right"><span class="mdi mdi-menu"></span></button>
          </div>
          <div class="row mx-0">
             <div class="col-xl-3 col-lg-4 col-md-4 chat-list-wrapper px-0" :class="{ active: isActive }">
              <!-- <div class="sidebar-spacer">
                <div class="input-group chat-search-input">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search Inbox"
                    aria-label="Username"
                  >
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i class="ti-zoom-in"></i>
                    </span>
                  </div>
                </div>
              </div>-->
              <div class="chat-list-item-wrapper">
                <!-- <div class="sidebar-spacer">
                  <button class="btn btn-block btn-primary py-2 mb-2 mt-2" type="button">+ New Chat</button>
                </div>-->
 
                <div class="dis-flex">
                  <h4 class="chat-list-title"># {{ $t('streams') }}</h4>
                  <a href="javascript:void(0)" @click="showAddStreamModal" target="_self" class="d-flex align-items-center add-stream-a" v-if="permissionExist('manage_streams')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle btn-add-stream">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="8" x2="12" y2="16"></line>
                      <line x1="8" y1="12" x2="16" y2="12"></line>
                    </svg>
                    <!-- <span class="menu-title text-truncate">Extensions</span> -->
                  </a>
                </div>
                <div class>
                  <ul>
                    <li class="stream-list-item" v-for="(stream, index) in streams" :key="index">
                      <div>
                        <a
                          href="javascript:void(0)"
                          class="stream-link"
                          :class="{'selected-stream': activeChat === stream.stream_id }"
                          @click="getFilteredStreams(stream.stream_id)"
                        >
                        <span> # {{stream.name}}</span>
                         <div class="chat-meta text-nowrap stream-noti">
                          <!-- <small class="float-right mb-25 chat-time">Sep 5</small> -->
                          <span class="badge float-right badge-primary badge-pill" :id="stream.stream_id"></span>
                        </div>
                        </a>
                       
                      </div>
                    </li>
                  </ul>
                </div>
                <!-- <div class="row" v-if="userLoader">
                  <div class="col-md-12 text-center m-2">
                    <rotate-square2></rotate-square2>
                  </div>
                </div> -->
                <h4 class="chat-list-title"># {{ $t('direct-messages') }}</h4>
                <div
                  v-for="(user, index) in users"
                  :key="index"
                  @click="getFilteredMessages(user.user_id)"
                >
                  <div
                    class="list-item"
                    :class="{'selected-chat': activeChat === user.user_id }"
                    v-if="validUser(user.email)"
                  >
                    <div class="profile-image">
                      <div class="dot-indicator sm bg-success" v-if="user.is_active == 1"></div>
                      <img
                        class="img-sm rounded-circle"
                        src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                        alt
                      >
                    </div>
                    <p class="user-name">{{user.full_name}}</p>
                    <div class="chat-meta text-nowrap">
                      <!-- <small class="float-right mb-25 chat-time">Sep 5</small> -->
                      <span class="badge float-right badge-primary badge-pill" :id="user.user_id"></span>
                    </div>
                    <!-- <p class="chat-time">30min ago</p>
                    <p
                      class="chat-text"
                    >Hello everyone, Iam happy to share with you our new company goals..</p>-->
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-9 col-lg-8 col-md-8 px-0 d-flex flex-column">
              <div id="chat-content" class="chat-container-wrapper chat-content">
                <div
                  class="chat-bubble"
                  :class="message.sender_email === userEmail ? 'outgoing-chat': 'incoming-chat'"
                  v-for="(message, index) in currentChat"
                  :key="index"
                >
                  <div class="chat-message message-box">
                    <p class="font-weight-bold">{{ message.sender_full_name }}</p>
                    <!-- <p> {{ message.content }} </p> -->
                    <div v-html="message.content"></div>
                    <!-- <p class="font-weight-medium">
                      <i class="ti-clip mr-2"></i>workfile.pdf
                    </p>-->
                  </div>
                  <!-- <div class="sender-details" v-if="message.flags.length">
                    <img
                      class="sender-avatar img-xs rounded-circle"
                      src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                      alt="profile image"
                    >
                    <p class="seen-text">Message Seen: 10 min ago</p>
                  </div>-->
                </div>
                <div class="emojis-section">
                  <Picker
                    :data="emojiIndex"
                    set="twitter"
                    @select="selectEmoji"
                    :hidden="!showEmojis"
                  />
                </div>
              </div>
              <div class="chat-text-field mt-auto">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <button
                      type="button"
                      class="input-group-text"
                      @click="showEmojis = !showEmojis"
                    >
                      <i class="ti-face-smile icon-sm"></i>
                    </button>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('type-message')"
                    v-model="message"
                    @click="fileUpload = false"
                    @keyup.enter="fireMessage"
                  >
                  <input
                    id="fileUpload"
                    type="file"
                    name="fileUpload"
                    :hidden="!fileUploaded"
                    @change="fileChanged($event)"
                  >
                  <div class="input-group-append">
                    <button type="button" class="input-group-text" @click="chooseFiles()">
                      <i class="ti-clip icon-sm"></i>
                    </button>
                  </div>
                  <div class="input-group-append">
                    <button type="button" class="input-group-text" @click="fireMessage()">
                      <i class="ti-share icon-sm"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="permissionExist('manage_streams')">
      <manage-streams :userEmail="userEmail" :users="users" :streams="streams" :streamOptions="streamOptions" :filterClientUsersOptions="filterClientUsersOptions" :filterClientUsers="filterClientUsers"></manage-streams>
    </div>

  </section>
</template>

<script>
import Vue from "vue";
import ZAPI from "@/zulip";
import 
API from "@/api";
import HFunction from "@/helper";
import Snotify, { SnotifyPosition } from "vue-snotify";
import {validationMixin} from "vuelidate";
import {required, minLength, email, requiredIf, sameAs} from "vuelidate/lib/validators";
import { Picker, EmojiIndex } from "emoji-mart-vue-fast";
// import { RotateSquare2 } from 'vue-loading-spinner'
import data from "emoji-mart-vue-fast/data/all.json";
import "emoji-mart-vue-fast/css/emoji-mart.css";
const zulipInit = require("zulip-js");
// var ZULIP_URL = "https://techleadz.zulipchat.com";
var ZULIP_URL = "https://spotter.chat";
let emojiIndex = new EmojiIndex(data);
import ChatLogin from "../components/apps/ChatLogin.vue";
import ManageStreams from "../components/apps/ManageStreams.vue";

const options = {
  toast: {
    position: SnotifyPosition.rightTop
  }
};
Vue.use(Snotify, options);

export default {
  name: "Chat",
  props: ["userEmailProp", "spotterAuth", "spotterChat"],
  components: {
    Picker,
    ChatLogin,
    ManageStreams,
    // RotateSquare2
  },
  mixins: [validationMixin],
  data() {
    return {
      isDisabled: false,
      message: "",
      userEmail: "",
      config: {
        username: "",
        apiKey: "",
        realm: ""
      },
      //  form: {
      //   subscriptions:{
      //     name: '',
      //     description: '',
      //   },
      //   principals: [],
      //   name: "",
      //   stream_desc: "",
      // },
      getPermissionsData: [],
      client: [],
      clientUsers: [],
      users: [],
      streams: [],
      streamOptions: [],
      currentChat: [],
      openInboxId: "",
      openStreamId: "",
      activeChat: "",
      selectedFile: "",
      fileUploaded: false,
      emojiIndex: emojiIndex,
      showEmojis: false,
      isActive: false,
      invalidUser: false,
      userLoggedIn: true,
      inboxType: "",
      timer: "",
      queueId: "1661490827:288",
      lastEventId: "",
      filterClientUsers: [],
      filterClientUsersOptions: [],
      userLoader: true
    };
  },
  validations: {
    form: {
        subscriptions: {
          name: {
            required
          },
          description:{
            required
          }
        },
        // stream_name: {
        //     required,
        // },
        // stream_desc: {
        //     required,
        // },
    }
  },
  methods: {
    getPermissions() {
      this.getPermissionsData = JSON.parse(localStorage.getItem('userPermissions'));
      console.log('this.getPermissionsData',this.getPermissionsData);
    },
    permissionExist(param) {
      var check = this.getPermissionsData.includes(param);
      if (check) {
          return true;
      } else {
          return false;
      }
    },
    changeSetings() {
      document.querySelector("body").classList.add("sidebar-icon-only");
      //   document.querySelector(".content-wrapper").style.padding = "0px";
    },
    selectEmoji(emoji) {
      this.message = this.message + " " + emoji.native;
    },
    myFilter: function() {
      console.log("working");
      this.isActive = !this.isActive;
    },
    getClientChatUsers() {
      var client_id = JSON.parse(localStorage.getItem("client_id"));
      if(client_id === null ) {
        client_id = this.spotterClientId;
      }
      const data = {
        spotterAuth: this.spotterAuth,
        client_id: client_id
      };
      const res = API.getClientChatUsers(
        data,
        data => {
          this.clientUsers = data.data;
        },
        err => {}
      );
      return res;
    },
    getUserData() {
      let data = {};
      console.log('this.spotterChat', this.spotterChat)
      console.log('this.userEmailProp', this.userEmailProp)
      console.log('this.client_id', this.spotterClientId)
      if(this.spotterAuth !== null || this.spotterChat === "yes") {
        this.userEmail = this.userEmailProp;
        data = {
          'spotter_email': this.userEmail,
          'spotterAuth': this.spotterAuth
        }
      }
      const res = API.getUserData(
        data,
        data => {
          this.userEmail = data.data.email;
          console.log(data.data.email);
          console.log(this.userEmail);
          this.apiKey = data.data.zulip_api_key;
          if (this.apiKey) {
            this.userLoggedIn = true;
          } else {
            this.userLoggedIn = false;
          }
          if(data.user === 'admin') {
            this.getPermissions();
          }
          this.config.username = this.userEmail;
          this.config.apiKey = this.apiKey;
          this.config.realm = ZULIP_URL;
          this.client = zulipInit(this.config);
        },
        err => {
          this.invalidUser = true;
          this.userLoggedIn = false;
        }
      );
      return res;
    },
    getAllUsers() {
      const config = {
        username: this.userEmail,
        apiKey: this.apiKey,
        realm: ZULIP_URL
      };

      (async () => {
        const client = await zulipInit(config);
        const users = await client.users.retrieve();
        if (users.result == "success") {
          this.users = users.members;
          console.log('userssssss', this.users);
          console.log('clientUserssssssss', this.clientUsers);
          this.filterClientUsers = this.users.filter(o1 => this.clientUsers.some(o2 => o1.email === o2.email));
          this.filterClientUsers.forEach(user => {
            this.filterClientUsersOptions.push(user);
          });
          this.userLoader = false;
        } else {
          this.invalidUser = true;
          this.userLoader = false;
        }
      })();
    },
    async fireMessage() {
      if (this.fileUploaded) {
        this.uploadFile();
      }else {
        this.showEmojis = false;
        if (this.inboxType === "stream") {
          this.sendMessageInStream();
        } else if (this.inboxType === "private") {
          this.sendMessageInPrivate();
        }
      }
    },
    async sendMessageInStream() {
      const config = {
        username: this.userEmail,
        apiKey: this.apiKey,
        realm: ZULIP_URL
      };
      const client = await zulipInit(config);

      (async () => {
        var user_id = this.openStreamId;
        let params = {
          type: this.inboxType,
          content: this.message,
          sender_id: user_id,
          // stream:
          // topic:
          stream_id: user_id,
          to: [user_id],
          topic: "all",
          locally_echoed: true
        };
        const res = await client.messages.send(params);
        if (res.result === "success") {
          this.getFilteredStreams(this.openStreamId);
        } else {
          this.$snotify.error(res.msg);
        }
      })();
      this.message = "";
    },
    async sendMessageInPrivate() {
      const config = {
        username: this.userEmail,
        apiKey: this.apiKey,
        realm: ZULIP_URL
      };
      const client = await zulipInit(config);
      var user_id = this.openInboxId;
      let params = {
        to: [user_id],
        type: this.inboxType,
        content: this.message
      };
      const res = await client.messages.send(params);
      if (res.result === "success") {
        this.getFilteredMessages(this.openInboxId);
      } else {
        this.$snotify.error(res.msg);
      }
      this.message = "";
    },
    async getAllMessages() {
      const config = {
        username: this.userEmail,
        apiKey: this.apiKey,
        realm: ZULIP_URL
      };
      const client = await zulipInit(config);
      const readParams = {
        anchor: "newest",
        num_before: 100,
        num_after: 0,
        // apply_markdown: false,
        narrow: [
          { operator: "sender", operand: this.userEmail },
          // { operator: "sender", this.userEmailcom" },
          { operator: "stream", operand: "general" }
        ]
      };

      const data = await client.messages.retrieve(readParams);
      this.currentChat = data.messages;
    },
    async getAllStreams() {
      const config = {
        username: this.userEmail,
        apiKey: this.apiKey,
        realm: ZULIP_URL
      };

      const client = await zulipInit(config);
      const data = await client.streams.retrieve();
      this.streams = data.streams;
      // this.streams.forEach(st => {
      //   this.streamOptions.push({'name': st.name, ''});
      // });
      this.streamOptions = this.streams;
    },
    getFilteredMessages: async function(id) {
      this.openInboxId = id;
      this.activeChat = id;
      this.inboxType = "private";
      this.showEmojis = false;
      const config = {
        username: this.userEmail,
        apiKey: this.apiKey,
        realm: ZULIP_URL
      };
      const client = await zulipInit(config);
      const readParams = {
        anchor: "newest",
        num_before: 1000,
        num_after: 1000,
        // apply_markdown: false,
        narrow: [
          { negated: false, operator: "pm-with", operand: [this.openInboxId] }
        ]
      };

      const data = await client.messages.retrieve(readParams);
      this.currentChat = data.messages;
      setTimeout(function() {
        HFunction.scrollToBottom("chat-content");
      }, 1000);
      this.removeNotification(id);
    },
    getFilteredStreams: async function(id) {
      this.openStreamId = id;
      this.activeChat = id;
      this.showEmojis = false;
      this.inboxType = "stream";
      const config = {
        username: this.userEmail,
        apiKey: this.apiKey,
        realm: ZULIP_URL
      };
      const client = await zulipInit(config);
      const readParams = {
        anchor: "newest",
        num_before: 1000,
        num_after: 1000,
        // apply_markdown: false,
        narrow: [
          { negated: false, operator: "stream", operand: this.openStreamId }
        ]
      };

      const data = await client.messages.retrieve(readParams);
      this.currentChat = data.messages;
      setTimeout(function() {
        HFunction.scrollToBottom("chat-content");
      }, 1000);
      this.removeNotification(id);
    },
    uploadFile: async function() {
      let Uploaded_file = "";
      const config = {
        username: this.userEmail,
        apiKey: this.apiKey,
        realm: ZULIP_URL
      };
      const client = await zulipInit(config);

      // this.selectedFile = event.target.files[0]
      // let data = {
      //   username: this.userEmail,
      //   // apiKey: this.apiKey,
      //   filename: this.selectedFile.name
      // };
      
      const data = new FormData();
      data.append('image', this.selectedFile, this.selectedFile.name);
      data.append('username', this.userEmail)
      data.append('apiKey', this.apiKey)
      await ZAPI.uploadFileToServer(
        data,
        async data => {
          console.log(data);
          if (data.status === 200) {
            Uploaded_file = data.data.uri;
            console.log('Uploaded_file', Uploaded_file);
            const content = ZULIP_URL + Uploaded_file
            const user_id = this.openInboxId;
            let params = {
              to: [user_id],
              type: "private",
              content: content
            };
            console.log(await client.messages.send(params));
            this.getFilteredMessages(this.openInboxId);
          } else {
            return false;
          }
        },
        err => {}
      );
    },
    chooseFiles() {
      document.getElementById("fileUpload").click();
      this.fileUploaded = true;
    },
    fileChanged(e) {
      console.log("inside function");
      this.fileUploaded = true;
      const selectedFile = e.target.files[0];
      this.selectedFile =  e.target.files[0];
      console.log(this.selectedFile);
      console.log(this.selectedFile.name);
    },
    callEvent() {
      const data = {
        username: this.userEmail,
        apiKey: this.apiKey,
        queue_id: this.queueId,
        last_event_id: this.lastEventId,
        spotterAuth: this.spotterAuth
      };
      ZAPI.event(
        data,
        data => {
          if (data.status === 200) {
            if (data.type === "new") {
              this.queueId = data.data;
            } else {
              // console.log("events", data.data.events);
              data.data.events.forEach((evnt, index) => {
                this.lastEventId = evnt.id;
                if (
                  evnt.type === "message" &&
                  evnt.message.sender_email !== this.userEmail
                ) {
                  if (evnt.message.type === "private") {
                    this.handleEventPrivateMessages(evnt.message);
                  } else if (evnt.message.type === "stream") {
                    this.handleEventStreamMessages(evnt.message);
                  }
                }
              });
            }
          } else if (data.status == 500) {
            // console.log(data);
          }
        },
        err => {}
      );
    },
    handleEventPrivateMessages: async function(message) {
      const config = {
        username: this.userEmail,
        apiKey: this.apiKey,
        realm: ZULIP_URL
      };
      const client = await zulipInit(config);
      const readParams = {
        anchor: "newest",
        num_before: 1000,
        num_after: 1000,
        // apply_markdown: false,
        narrow: [
          { negated: false, operator: "pm-with", operand: [message.sender_id] }
        ]
      };

      if (message.sender_id === this.openInboxId) {
        const data = await client.messages.retrieve(readParams);
        this.currentChat = data.messages;
        this.readFlag(message.id);
        var noteTitle = message.sender_full_name;
        var noteOptions = {
            body: message.content,
            icon: "typewriter.jpg",
        };

        new Notification(noteTitle, noteOptions);
      } else {
        this.managePrivateNotifications(message);
      }
    },
    handleEventStreamMessages: async function(message) {
      const config = {
        username: this.userEmail,
        apiKey: this.apiKey,
        realm: ZULIP_URL
      };
      const client = await zulipInit(config);
      const readParams = {
        anchor: "newest",
        num_before: 1000,
        num_after: 1000,
        // apply_markdown: false,
        narrow: [
          { negated: false, operator: "stream", operand: message.sender_id }
        ]
      };

      if (message.sender_id === this.openStreamId) {
        const data = await client.messages.retrieve(readParams);
        this.currentChat = data.messages;
        this.readFlag(message.id);
      } else {
        this.manageStreamNotifications(message);
      }
    },
    readFlag: async function(id) {
      const config = {
        username: this.userEmail,
        apiKey: this.apiKey,
        realm: ZULIP_URL
      };
      const client = await zulipInit(config);
      const readParams = {
        messages: [id],
        op: "add",
        flag: "read"
      };
      // client.messages.flags(readParams);
      client.messages.flags.add(readParams);
    },
    managePrivateNotifications(message) {
      const div = document.getElementById(message.sender_id);
      var value = div.innerHTML;
      value = isNaN(div.innerHTML) ? 1 : value;
      value++;
      div.innerText = value;
      let data = {
        sender_id: message.sender_id,
        count: div.innerText
      };

      var noteTitle = message.sender_full_name;
      var noteOptions = {
          body: message.content,
          icon: "typewriter.jpg",
      };

      new Notification(noteTitle, noteOptions);

      var messages = JSON.parse(localStorage.getItem("messages"));
      var foundIndex = messages.findIndex(
        x => x.sender_id == message.sender_id
      );
      if (foundIndex !== -1) {
        messages[foundIndex] = data;
      } else {
        messages.push(data);
      }
      localStorage.setItem("messages", JSON.stringify(messages));
    },
    manageStreamNotifications(message) {
      const div = document.getElementById(message.stream_id);
      var value = div.innerHTML;
      value = isNaN(div.innerHTML) ? 1 : value;
      value++;
      div.innerText = value;
      let data = {
        stream_id: message.stream_id,
        count: div.innerText
      };
      var messages = JSON.parse(localStorage.getItem("messages"));
      var foundIndex = messages.findIndex(
        x => x.stream_id == message.stream_id
      );
      if (foundIndex !== -1) {
        messages[foundIndex] = data;
      } else {
        messages.push(data);
      }
      localStorage.setItem("messages", JSON.stringify(messages));
    },
    validUser(email) {
      return this.clientUsers.some(n => n.email === email);
    },
    setNotifications() {
      var messages = JSON.parse(localStorage.getItem("messages"));
      messages.forEach(function(i) {
        console.log("test", i.sender_id);
        const div = document.getElementById(i.sender_id);
        div.innerHTML = i.count;
      });
    },
    removeNotification(sender_id) {
      var messages = JSON.parse(localStorage.getItem("messages"));
      const div = document.getElementById(sender_id);
      div.innerHTML = "";
    },
    showAddStreamModal() {
      this.$root.$emit("bv::show::modal", "add-stream");
      // this.$refs['add-stream'].show();
    },
  },
  computed: {},
  async created() {
    this.$EventBus.$on("userLoggedIn", async data => {
    await this.getUserData();
      if (this.apiKey) {
        await this.getClientChatUsers();
        this.getAllUsers();
        this.getAllMessages();
        // this.getAllUsers();
        this.getAllStreams();
      }
    });
    this.$EventBus.$on("getAllStreams", (data) => {
      this.getAllStreams();
    });
  },
  async beforeMount() {},
  async mounted() {
    await this.getUserData();
    this.timer = setInterval(() => {
      this.callEvent();
    }, 10000);
    if (this.apiKey) {
      await this.getClientChatUsers();
      this.getAllUsers();
      this.getAllMessages();
      // this.getAllUsers();
      this.getAllStreams();
      this.setNotifications();
      // localStorage.setItem('messages', JSON.stringify([]));
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style scoped lang="scss">
::v-deep .client-dashbboard .main-panel .content-wrapper {
  padding: 0px !important;
}
.client-dashbboard .main-panel .content-wrapper{
  padding: 20px;
}
.chatbar-toggle {
    display: none;
}
.chat-content {
  background-image: url(data:image/svg+xml;base64,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);
  background-color: #f2f0f7;
  background-repeat: repeat;
  background-size: 210px;
  max-height: 500px;
}
.message-box {
  background-color: #fff;
  box-shadow: 0 4px 8px 0 rgb(34 41 47 / 12%);
  -webkit-box-shadow: 0 4px 8px 0 rgb(34 41 47 / 12%);
  border-radius: 0.357rem;
  padding: 0.7rem 1rem;
  max-width: 75%;
  font-family: Montserrat, Helvetica, Arial, serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.45;
  color: #6e6b7b;
}
.chat-app-wrapper .chat-container-wrapper{
  min-height: 66.5vh;
}
.chat-heading {
  padding: 10px 20px 10px;
  background: #e7e7e7;
}
.streams {
  padding-left: 30px;
}
.selected-chat {
  // background-image: linear-gradient(80deg, #7367f0, #9e95f5);
  background: linear-gradient(250deg, #7367f0, rgba(0, 38, 48, 1));

  .user-name {
    color: #fff !important;
  }
}
.chat-list-title {
  color: #7367f0;
  margin: 2rem 1.286rem 0.5rem;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.2;
}
.stream-link {
  background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
  box-shadow: 0 0 10px 1px rgb(115 103 240 / 70%);
  border-radius: 4px;
  color: #fff;
  font-weight: 400;
  margin: 0 15px;
  line-height: 1.45;
  outline: none;
  display: flex !important;
  text-decoration: none;
  padding: 10px 15px 10px 15px;

  &:hover {
    background: linear-gradient(250deg, #7367f0, rgba(0, 38, 48, 1));
  }
  &:active {
    background: linear-gradient(250deg, #7367f0, rgba(0, 38, 48, 1));
  }
}
.selected-stream {
  background: linear-gradient(250deg, #7367f0, rgba(0, 38, 48, 1));
}
.btn-primary {
  border-color: #7367f0 !important;
  background-color: #7367f0 !important;
  box-shadow: none;
  border: 1px solid transparent;
  padding: 0.786rem 1.5rem;
  border-radius: 0.358rem;
  color: #fff !important;
  font-weight: 500;
}
.btn-block {
  display: block;
  width: 100%;
}
.stream-list-item {
  list-style: none;
  margin-top: 0.5rem;
}
input[type="file"] {
  display: none !important;
}

.emojis-section {
  display: flex;
}
.emojis-section > * {
  // margin: auto;
}.stream-noti{
  position: absolute;
  right: 30px;
}
p > a{
  color: white;
  text-decoration: underline;
}

@media (max-width: 768px){
  .chat-app-wrapper .chat-list-wrapper{
    position: static;
  }
}
@media (max-width: 767.98px){
  .chat-app-wrapper .chat-list-wrapper{
    position: absolute;
  }
  .chatbar-toggle {
    display: block;
    z-index: 9;
    position: relative;
}
.chat-app-wrapper .chat-list-wrapper.active {
    left: 0;
}
.chat-app-wrapper .chat-list-wrapper{
  top: 25px;
}
.chat-app-wrapper .chat-container-wrapper[data-v-f917bc5a] {
    min-height: 59vh;
}
.chat-app-wrapper .chat-container-wrapper .chat-bubble.outgoing-chat .chat-message {
    max-width: 250px;
    margin-right: 0;
}
.chat-app-wrapper .chat-container-wrapper .chat-bubble .chat-message {
    padding: 12px;
}
}
@media (max-width: 574.98px){
  .chat-app-wrapper .chat-container-wrapper .chat-bubble.outgoing-chat .chat-message[data-v-f917bc5a] {
    max-width: 200px;
  }
  .chat-app-wrapper .chat-list-wrapper{
    width: 250px;
    left: -250px;
  }
  .chat-app-wrapper .chat-list-wrapper .chat-list-item-wrapper {
    padding-bottom: 25px;
    width: 245px;
  }
  svg{
    overflow: hidden;
    vertical-align: middle;
    height: 20px;
    width: 20px;
    font-size: 1.45rem;
    -ms-flex-negative: 0;
    flex-shrink: 0;
        position: relative;
    top: 1px;
  }
  .btn-add-stream {
    color: #7367f0;
    height: 20px;
    width: 20px !important;
    font-size: 1.45rem;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    outline: none;
    font-family: feather!important;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
  }
}
</style>
